import { useCallback } from 'react';
import useRequestByHouse from './useRequestByHouse';

export const useGetCountIndicators = () => {
  const { requests = [] } = useRequestByHouse();

  const getIndicators = useCallback(
    (addressId) => {
      if (!addressId) return { sumDeadline: 0, sumExpired: 0, sumExcess: 0 };

      const requestFind = requests?.find(
        (request) => request.addressId === addressId
      );

      if (!requestFind) return { sumDeadline: 0, sumExpired: 0, sumExcess: 0 };

      return {
        sumDeadline: requestFind?.sumDeadline || 0,
        sumExpired: requestFind?.sumExpired || 0,
        sumExcess: requestFind?.sumExcess || 0,
      };
    },
    [requests]
  );

  return getIndicators;
};
